const getters = {
  visibleColumns: state => {
    return state.columns.filter(x => x.showColumn);
  },
};

export default getters;
